import { featurePanelContext } from './featurePanelContext';
import { useContext } from 'react';
/**
 * Hook to access FeaturePanel's shared context.
 */
export const useFeaturePanel = () => {
    const context = useContext(featurePanelContext);
    if (!context) {
        throw new Error('Cannot use `useFeaturePanel` outside of `FeaturePanelProvider`');
    }
    return context;
};
